import { OrganizationSubjects } from '@/enums/OrganizationSubjects'

export default {
  props: {
    form: {
      type: Object,
      default: () => ({})
    },

    terminalRegions: {
      type: Array,
      default: () => []
    },

    approveForm: {
      type: Object,
      default: () => ({})
    },

    errors: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    isGkoOrganizationSubject () {
      return this.form.organization.subject_id === OrganizationSubjects.Gko
    },

    terminalRegion() {
      return this.terminalRegions.find(region => region.id === this.form.application.terminal_region_id);
    }
  },

  methods: {
    getGivePassUrl(isGivePassPeriod) {
      return String(
        this.baseUrl + '/pdf/pass?' +
          'applicationId=' + this.form.application.id +
          '&visitorId=' + this.visitor.personal.id +
          '&transportId=' + (this.visitor.transports[this.transportIndex]?.id ?? '') +
          '&isGivePassPeriod=' + isGivePassPeriod ?? false
      )
    }
  }
}
